import React, { useEffect, useState } from 'react'
import { withCookies } from 'react-cookie'
import axios from '../../axios'
import { DOMAIN } from '../../constants'

function withErrorHandler(WrappedComponent) {
  return (props) => {
    const [error, setError] = useState(null)
    const { cookies } = props

    const reqInterceptor = axios.interceptors.request.use((req) => {
      return req
    })

    const parseJWT = (token) => {
        let base64Url = token.split('.')[1];
        let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        return JSON.parse(window.atob(base64));
    }

    const resInterceptor = axios.interceptors.response.use(
      (res) => res,
      (error) => {
        console.log('error in axios.interceptors.response:', error)
        
        const status = error.request?.status

        if (window.ReactNativeWebView) {
          // RN WebView: native host owns the token — never wipe it from the page.
          // Notify the host only for auth errors (401/403) so it can re-auth /
          // close; other errors (400/500/network) the page handles itself.
          if (status === 401 || status === 403) {
            window.ReactNativeWebView.postMessage(
              JSON.stringify({ type: 'AUTH_ERROR', status })
            )
          }
        } else if (status === 403) {
          // Web: existing logout — the guard in Layout redirects to login once
          // the TOKEN cookie is gone.
          const token = parseJWT(cookies.get('TOKEN'))
          if (token?.email) {
            sessionStorage.setItem('email_for_redirect', token.email)
          }

          cookies.remove('TOKEN', {
            path: '/',
            domain: "." + window.location.hostname.split(".").reverse()
              .slice(0, 2).reverse()
              .join(".")
          })
        }

        setError(error)
        return Promise.reject(error)
      }
    )

    useEffect(() => {
      return () => {
        axios.interceptors.request.eject(reqInterceptor)
        axios.interceptors.response.eject(resInterceptor)
      }
    }, [])

    return <WrappedComponent {...props} />
  }
}

export default (WrappedComponent) => {
  return withCookies(withErrorHandler(WrappedComponent))
}